import React from "react";
import { styled } from "styled-components";
import { Color } from "@/common/colors/colors";
import SelectInput from "@/common/components/custom/SelectInput";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";

const SelectBarContainer = styled.div`
  border-radius: 10px;
  background-color: ${Color.White};
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  box-shadow: 0px 2px 10px ${Color.Grey};
  width: fit-content;
  gap: 10px;
`;

const SearchButton = styled.button`
  padding: 10px 20px;
  background-color: ${Color.DarkBlue};
  color: ${Color.White};
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  margin-left: 20px;

  &:hover {
    background-color: ${Color.Grey};
  }
`;

const SearchBar = ({
  options,
  selectedCoreOptions,
  setSelectedCoreOption,
  handleSearch,
  setEditLevel,
}) => {
  return (
    <SelectBarContainer>
      <SelectInput
        width={140}
        name="Core Language"
        color={Color.DarkBlue}
        selectWidth={200}
        options={options}
        selected={selectedCoreOptions}
        setSelected={setSelectedCoreOption}
      />
      <SearchButton onClick={handleSearch}>Search</SearchButton>
      <CustomEditButton
        text={<FontAwesomeIcon icon={faAdd} />}
        onClick={() => setEditLevel({})}
      />
    </SelectBarContainer>
  );
};

export default SearchBar;
